const PartPopper = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="1em"
      height="1em"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 64 64"
    >
      <path fill="#f7b600" d="m2 61l8.6-3l-6.5-3z" />
      <path fill="#ffdd7d" d="M26.9 36.4L14.8 24.2l-2 5.6z" />
      <path
        fill="#f7b600"
        d="m12.8 29.8l-2.2 6.3l26.8 12.5l1.3-.4l-11.8-11.8z"
      />
      <path fill="#ffdd7d" d="m8.5 42.4l20 9.3l8.9-3.1l-26.8-12.5z" />
      <path fill="#f7b600" d="m6.3 48.7l13.2 6.2l9-3.2l-20-9.3z" />
      <path fill="#ffdd7d" d="M6.3 48.7L4.1 55l6.5 3l8.9-3.1z" />
      <path
        fill="#493816"
        d="M31.9 31.2c6.7 6.6 10.2 14 7.8 16.4c-2.5 2.4-9.9-1-16.7-7.7c-6.7-6.6-10.2-14-7.8-16.4c2.5-2.4 9.9 1.1 16.7 7.7"
      />
      <path
        fill="#42ade2"
        d="M23.5 14.5c-1.6-2.3.1-3.3 2.3-2.9c-2.1-2.5-.8-4.3 2.5-3.6c1 .2-.4 1.9-1.3 1.9c2.7 2 1.2 4.2-1.7 3.7c2.6 3.5-1.8 2.6-3.8 2.8C21 19 24 22 23 22c-2.2 0-5.8-8.3.5-7.5"
      />
      <path
        fill="#ff8736"
        d="M44.5 19.3c-1.5.7-5.7-5.9-.5-6c-3-2.7-2.6-4 1.4-4.1c-4.6-4.6 2.7-6.2 3.4-3.8c.2.7-2.2-.6-3 .7c-.9 1.5 5.6 5.4-1.1 5.1c2.5 2.5 2.6 3.7-1.3 4.1c.5.8 2.1 3.6 1.1 4"
      />
      <path
        fill="#ed4c5c"
        d="m46.2 34.9l1.5-1.3s1.4 2.1 2.4 2.9c.8-3.6.6-5.7 4.7-3.3c-2.3-6.2 1.5-3.9 5.2-2.2c-.2-1.6 0-1.4 1.6-1.9c1.4 5.3-2.4 3.7-5.4 2c1.8 4.8-.1 4.5-3.9 2.9c-.1 2-.7 4.3-1.9 4.5c-1.4.4-4.2-3.6-4.2-3.6"
      />
      <path
        fill="#c28fef"
        d="M35 20.1c-1.8 2.4-4.7 3.7-6.8 5.8c-2.2 2.2-3.5 8.2-3.5 8.2s.8-6.3 2.9-8.7c1.9-2.2 4.7-3.8 6.2-6.3c2.6-4.6.2-10.6-3.2-14.1c.7-.6 1.7-1.4 2.2-2c3.3 4.1 6.1 12 2.2 17.1"
      />
      <path
        fill="#ff8736"
        d="M38.1 25.2c-2.6 1.9-4.5 4.7-6.3 7.3c-1.6 2.3-6.7 5.2-6.7 5.2s4.8-3.3 6.3-5.7c1.8-3 3.6-6.1 6.4-8.3c5.6-4.3 13.7-3.9 20-1.6c-.4.9-1.1 2.8-1.1 2.8s-13.3-3.6-18.6.3"
      />
      <path
        fill="#42ade2"
        d="M49.2 24.7c-1.7 2.2-2.5 4.9-3.8 7.4c-1.2 2.3-2.8 4.5-5.1 5.7c-2.6 1.3-8.3.9-8.3.9s5.7-.1 8.1-1.7c2.4-1.6 3.7-4.4 4.6-7c1.8-5 4-10.4 9.2-12.6c.3.9 1 2.8 1 2.8s-2.9.8-5.7 4.5M3.21 14.325l2.828-2.829l2.829 2.828l-2.828 2.83z"
      />
      <path fill="#ff8736" d="M7.173 23.197L10 20.369l2.828 2.828L10 26.025z" />
      <path
        fill="#ed4c5c"
        d="m14.358 9.822l2.828-2.828l2.828 2.828l-2.828 2.828z"
      />
      <path
        fill="#c28fef"
        d="m45.205 43.696l2.828-2.829l2.828 2.829l-2.828 2.828z"
      />
      <path
        fill="#ed4c5c"
        d="m38.903 53.39l2.828-2.828l2.829 2.829l-2.829 2.828z"
      />
      <path
        fill="#ff8736"
        d="m51.279 55.607l2.828-2.829l2.828 2.829l-2.828 2.828z"
      />
      <path
        fill="#42ade2"
        d="m54.078 42.731l2.828-2.828l2.828 2.828l-2.828 2.829zm-4.722-29.908l2.828-2.829l2.829 2.829l-2.828 2.828z"
      />
      <path
        fill="#ed4c5c"
        d="m19.044 29.792l2.829-2.828l2.828 2.828l-2.828 2.829z"
      />
    </svg>
  );
};
export default PartPopper;